import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, Newspaper } from 'lucide-react';

const NewsSection = () => {
  const newsItems = [
    {
      id: 1,
      title: 'New UK Gambling Regulations: What Players Need to Know',
      excerpt: 'The latest updates from the UK Gambling Commission bring enhanced player protections and new responsible gambling measures. Learn how these changes affect your gaming experience.',
      date: '28.10.2025',
      slug: 'new-uk-gambling-regulations-2025',
      category: 'Regulations'
    },
    {
      id: 2,
      title: 'Top 5 Slot Games Dominating UK Casinos in 2025',
      excerpt: 'Discover the most popular slot titles that have taken the UK online casino scene by storm this year, featuring cutting-edge graphics and innovative bonus features.',
      date: '28.10.2025',
      slug: 'top-5-slot-games-2025',
      category: 'Games'
    },
    {
      id: 3,
      title: 'Understanding Casino Bonus Wagering Requirements',
      excerpt: 'A comprehensive guide to bonus terms and conditions, helping you understand wagering requirements and how to maximize your bonus value effectively.',
      date: '28.10.2025',
      slug: 'casino-bonus-wagering-requirements-guide',
      category: 'Guides'
    }
  ];

  return (
    <section className="py-20 px-4">
      <div className="container mx-auto">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 mb-4">
              <Newspaper className="w-6 h-6 text-green-600" />
              <span className="text-sm font-semibold text-green-600 uppercase tracking-wide">Latest News</span>
            </div>
            <h2 className="pb-2 text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-pink-600 to-green-600 bg-clip-text text-transparent">
              Casino Industry News & Updates
            </h2>
            <p className="text-xl text-gray-700 max-w-2xl mx-auto">
              Stay informed with the latest developments, trends, and expert insights from the UK online casino industry
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {newsItems.map((news, index) => (
              <article key={news.id} itemScope itemType="https://schema.org/NewsArticle" className="glass-strong rounded-3xl overflow-hidden group hover:transform hover:scale-105 transition-all duration-300 flex flex-col">
                <Link
                  to={`/news/${news.slug}`}
                  className="flex flex-col flex-grow"
                  data-discover="true"
                  itemProp="url"
                >
                  {/* News Image */}
                  <div className="relative h-48 bg-gradient-to-br from-pink-200 via-green-200 to-pink-300 overflow-hidden" style={{ backgroundImage: `url("/images/${news.id === 1 ? 'marin-tulard-9sbO_vzyG40-unsplash.jpg' : news.id === 2 ? 'markus-spiske-khurOlBGbQ8-unsplash.jpg' : 'point-normal-44cKaUuRmBg-unsplash.jpg'}")`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                    <div className="absolute top-4 left-4">
                      <span className="glass px-3 py-1 rounded-full text-white text-xs font-semibold">
                        {news.category}
                      </span>
                    </div>
                    <div className="absolute bottom-4 left-4 right-4 flex items-center space-x-2 text-white/90 text-sm">
                      <Calendar className="w-4 h-4" />
                      <time itemProp="datePublished" dateTime="2025-10-28">
                        <span>{news.date}</span>
                      </time>
                    </div>
                  </div>

                  <div className="p-6 flex-grow flex flex-col">
                    <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-green-600 transition-colors line-clamp-2" itemProp="headline">
                      {news.title}
                    </h3>
                    <p className="text-gray-600 mb-4 leading-relaxed flex-grow line-clamp-3" itemProp="description">
                      {news.excerpt}
                    </p>
                    <div className="flex items-center text-green-600 font-semibold group-hover:translate-x-2 transition-transform">
                      <span className="text-sm">Read More</span>
                      <ArrowRight className="w-4 h-4 ml-2" />
                    </div>
                  </div>
                </Link>
                <div itemProp="publisher" itemScope itemType="https://schema.org/Organization" style={{ display: 'none' }}>
                  <span itemProp="name">Crown Jackpot</span>
                </div>
              </article>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/news"
              className="inline-flex items-center space-x-2 px-8 py-4 glass-strong rounded-full font-semibold text-gray-700 hover:text-green-600 transition-colors"
              data-discover="true"
            >
              <span>View All News</span>
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;

